import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EventsService } from 'src/app/shared/services/events.service';
import { AuthService } from '../../services/auth.service';
import { EncryptionService } from '../../services/encryption.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  createPassForm:any;
  domainUrl
  returnUrl
  id;
  otp;
  passwordText:boolean=false;
  confPasswordText:boolean=false;
  constructor( private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private eventsService: EventsService,
    private encryptionService: EncryptionService,
    private toaster: ToastrService) { 

    this.createPassForm = this.formBuilder.group({
      newPassword:[null,[Validators.required , Validators.minLength(8)]],
     confirmNewPassword:[null,[Validators.required ]]
 
     
    },
    {
     validator : this.mustMatch('newPassword', 'confirmNewPassword')
    })
  }
  
  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }

  onSubmitPass(){
    // this.submitted = true;
    

    // stop here if form is invalid
    if (this.createPassForm.invalid) {
      return;
    }
   
    let data = { newPassword : this.encryptionService.encryptData(this.createPassForm.controls.confirmNewPassword.value),  otp :this.otp, uniqueNumber: this.id }
    this.authService.resetPassword(data).subscribe((res) => {
      if (res) {
        this.toaster.success("Password changed successfully.");
        setTimeout(() => {
          this.router.navigate(["/login"]);  
        }, 2000);
      }
    });

  }
  ngOnInit(): void {
    // this.domainUrl = environment.businessDomain;
    // get return url from route parameters or default to '/'
    // console.log(window.location.pathname,window.location);
    // if(window.location.pathname=="/login7"){
    //   this.showResetPassSection=true;
    //   // this.showForgotSection=true;
    // }else{
    //   // this.showForgotSection=true;
    // }
     this.id = this.route.snapshot.paramMap.get('id');
     this.otp= this.route.snapshot.paramMap.get('otp')
    console.log(this.id);
    // this.returnUrl = this.route.snapshot.queryParams['id'] || '';
    // this.router.navigate([this.returnUrl]);

   
    this.createPassForm.valueChanges.subscribe((val: any) => {
      if (val) {
        // this.error = '';
      }
    });
  }

  togglePassword(value) {
    if(value=='newPass')
    {
      this.passwordText = !this.passwordText;

    }else{
      this.confPasswordText = !this.confPasswordText;
    }
  }

}
